import { render, staticRenderFns } from "./marketValue.vue?vue&type=template&id=6b8d7802&scoped=true&"
import script from "./marketValue.vue?vue&type=script&lang=js&"
export * from "./marketValue.vue?vue&type=script&lang=js&"
import style0 from "./marketValue.vue?vue&type=style&index=0&id=6b8d7802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8d7802",
  null
  
)

export default component.exports